import { render, staticRenderFns } from "./NoteEditorPanel.vue?vue&type=template&id=81231402&scoped=true&"
import script from "./NoteEditorPanel.vue?vue&type=script&lang=js&"
export * from "./NoteEditorPanel.vue?vue&type=script&lang=js&"
import style0 from "./NoteEditorPanel.vue?vue&type=style&index=0&id=81231402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81231402",
  null
  
)

export default component.exports